import { render } from "./FrameItem.vue?vue&type=template&id=774358bf&scoped=true"
import script from "./FrameItem.vue?vue&type=script&lang=js"
export * from "./FrameItem.vue?vue&type=script&lang=js"

import "./FrameItem.vue?vue&type=style&index=0&id=774358bf&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-774358bf"]])

export default __exports__